module.exports = function() {
  return new Worker(__webpack_public_path__ + "e51958bc844300f8c419.worker.js");
};